import React from 'react';
import classNames from "classnames";
import styles from './XRow.module.scss';
import { XComponent } from '../commons';
import { IRowProps } from './IRowProps';
import { IRowState } from './IRowState';

export class XRow extends XComponent<HTMLDivElement, IRowProps, IRowState> {
    static defaultProps = {
        ...XComponent.defaultProps
    }
    public constructor(props: IRowProps) {
        super(props);
    }
    
    public componentDidMount(): void{
        super.componentDidMount();
    }
    public componentWillUnmount(): void{}
    
    public render(): React.ReactNode {
        return (
            <div ref={this.reference} className={classNames(styles.XRow, this.props.className)}>
                {this.props.children}
            </div>
        );
    }
}
